import AssignmentIcon from '@material-ui/icons/Assignment';
import React from 'react';
import styled from 'styled-components';
import Box from '../../../components/Box';
import BoxBody from '../../../components/Box/BoxBody';
import BoxHeader from '../../../components/Box/BoxHeader';
import Layout from '../../../components/Layout';
import Closures from './components/Closures';

const MainContentWrapper = styled.div`
  padding: 20px;
`;
const DashboardPage = () => {
  return (
    <Layout>
      <MainContentWrapper>
        <ClosureCard />
      </MainContentWrapper>
    </Layout>
  );
};

export default DashboardPage;

const ClosureCard = () => {
  return (
    <Box>
      <BoxHeader icon={<AssignmentIcon />} color={'#ff0000'} title={'Denní uzávěrky'} />
      <BoxBody>
        <Closures />
      </BoxBody>
    </Box>
  );
};
